"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _animations = require("@qc-modules/animations");

var _components = require("../../components");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  // Delay value for animation
  delayIn: _propTypes.number,
  // Number of maximum items to show
  extraItemsCount: _propTypes.number.isRequired,
  // Whether restricted or regular resource
  isRestricted: _propTypes.bool,
  // Boolean passed to MoreButton isExpaned, tied to showMoreOnClick
  showAllResults: _propTypes.bool,
  // Boolean passed to MoreButton isExpaned
  showMoreOnClick: _propTypes.func
};

var ShowMore = function ShowMore(_ref) {
  var delayIn = _ref.delayIn,
      extraItemsCount = _ref.extraItemsCount,
      isRestricted = _ref.isRestricted,
      showAllResults = _ref.showAllResults,
      showMoreOnClick = _ref.showMoreOnClick;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    justifyContent: "flex-start",
    mt: 3,
    px: 2
  }, isRestricted ? /*#__PURE__*/_react["default"].createElement(_animations.SlideIn, {
    alwaysShowInDom: true,
    delayIn: delayIn,
    fadeInOut: true,
    vertical: -1
  }, /*#__PURE__*/_react["default"].createElement(_components.MoreButton, {
    isExpanded: showAllResults,
    toggleIsExpanded: showMoreOnClick
  })) : !showAllResults && /*#__PURE__*/_react["default"].createElement(_components.Cta, {
    darkUi: false,
    onClick: showMoreOnClick,
    size: "small",
    version: "tertiary"
  }, "Show " + extraItemsCount + " more"));
};

ShowMore.propTypes = propTypes;
ShowMore.displayName = "Modules.ShowMore";
var _default = ShowMore;
exports["default"] = _default;